import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-label-modal-subtitle',
    imports: [CommonModule],
    template: `
    <div class="font-normal text-sm text-neutral-600 dark:text-night-300">
      {{ label }}
      <ng-content></ng-content>
    </div>
  `
})
export class LabelModalSubtitleComponent {
  @Input() label!: string;
  @Input() customClass!: string;
  @Input() useCustomClass = false;
}
